import { render, staticRenderFns } from "./OilAreaList.vue?vue&type=template&id=31cd1988&scoped=true&"
import script from "./OilAreaList.vue?vue&type=script&lang=ts&"
export * from "./OilAreaList.vue?vue&type=script&lang=ts&"
import style0 from "./OilAreaList.vue?vue&type=style&index=0&id=31cd1988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd1988",
  null
  
)

export default component.exports